import React from 'react';

const ImplantCourse = ({ onOpenForm }) => {

  return (
    <section id="curso" className="py-16 bg-neutral-lightest">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 mb-10 lg:mb-0 lg:pr-12">
            <div className="mb-2 text-center lg:text-left">
              <h2 className="text-3xl font-sans font-bold mb-2 text-primary">Curso de Implantes Hormonais</h2>
              <div className="w-24 h-1 bg-secondary mb-6 mx-auto lg:mx-0"></div>
            </div>
            
            <p className="mb-4 text-gray-700 leading-relaxed text-center lg:text-left">
              O Curso de Implantes Hormonais do Dr. Guthyerres Carvalho é uma formação completa e prática, desenvolvida para médicos que desejam dominar esta técnica terapêutica cada vez mais requisitada. Com foco na aplicação clínica e resultados reais, o curso combina fundamentação teórica sólida com treinamento prático supervisionado.
            </p>
            
            <p className="mb-6 text-gray-700 leading-relaxed text-center lg:text-left">
              Os participantes aprenderão desde os princípios básicos da terapia hormonal até as técnicas mais avançadas de implantes, incluindo indicações, contraindicações, dosagens, técnicas de aplicação e acompanhamento dos pacientes. O curso também aborda a gestão de possíveis complicações e estratégias para otimização de resultados.
            </p>
            
            <h3 className="text-xl font-sans font-semibold mb-4 text-primary text-center lg:text-left">O que você vai aprender:</h3>
            
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5 mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Fundamentos da terapia hormonal e suas aplicações clínicas</span>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5 mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Técnicas de implante hormonal passo a passo</span>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5 mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Avaliação clínica e laboratorial para indicação de implantes</span>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5 mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Condutas personalizadas para diferentes perfis de pacientes</span>
              </li>
              <li className="flex items-start">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary/20 flex items-center justify-center mt-0.5 mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">Gestão de possíveis complicações e efeitos adversos</span>
              </li>
            </ul>
            
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a 
                href="https://pt.surveymonkey.com/r/R7CD6CV"
                target="_blank" rel="noopener noreferrer"
                className="bg-secondary hover:bg-secondary-light text-primary-dark font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
              >
                Inscreva-se na Mentoria
              </a>
              <a 
                href="https://linktr.ee/DrGuthyerrescarvalho?fbclid=PAZXh0bgNhZW0CMTEAAafF8h6c4PqQZ6cSJHn3B1X5SuklnJX5RWx5FSWT40tJCZ2q1g5iIjpNyQTi2Q_aem_KCsT9VxDXqgyRVYaVvnEig"
                target="_blank" rel="noopener noreferrer"
                className="bg-primary hover:bg-primary-medium text-neutral-lightest font-bold py-3 px-8 rounded-full text-center transition-colors duration-300 shadow-soft"
              >
                Inscreva-se no Curso
              </a>
            </div>
          </div>
          
          <div className="lg:w-1/2">
            <div className="bg-primary/5 p-8 rounded-lg shadow-medium border border-primary/10">
              <h3 className="text-2xl font-sans font-bold mb-6 text-primary text-center lg:text-left">Diferenciais do Curso</h3>
              
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-sans font-semibold mb-1 text-primary">Material Didático Completo</h4>
                    <p className="text-gray-700">Acesso a apostilas, vídeos e materiais de referência exclusivos para consulta durante e após o curso.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-sans font-semibold mb-1 text-primary">Certificação de conclusão</h4>
                    <p className="text-gray-700">Certificado de conclusão que atesta sua capacitação na técnica de implantes hormonais.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-sans font-semibold mb-1 text-primary">Turmas Reduzidas</h4>
                    <p className="text-gray-700">Grupos pequenos para garantir atenção individualizada e melhor aproveitamento do conteúdo prático.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-sans font-semibold mb-1 text-primary">Flexibilidade de Datas</h4>
                    <p className="text-gray-700">Diversas opções de turmas ao longo do ano para que você possa escolher a que melhor se adapta à sua agenda.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-sans font-semibold mb-1 text-primary">Suporte Contínuo</h4>
                    <p className="text-gray-700">Suporte via WhatsApp e acesso a uma comunidade exclusiva de alunos para troca de experiências e dúvidas.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImplantCourse;


